//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { Opaque } from '@utils/opaque';

type GaProfileId = Opaque<string, 'GaProfileId'>;

function GaProfileIdFactory(gaProfileId: string) {
  return gaProfileId as GaProfileId;
}

const GaProfileId = GaProfileIdFactory;

export default GaProfileId;
